export enum RoleEnum {
  ADMIN = 'Admin',
  DESIGNER = 'Designer',
  SUPER_USER = 'SuperUser',
  VIEWER = 'Viewer',
}
